export const ROOT = `/`;

export const BACKOFFICE_LAYOUT = `/backoffice`;

export const DASHBOARD = `${BACKOFFICE_LAYOUT}/dashboard`;

export const ORDERS = `${BACKOFFICE_LAYOUT}/orders`;

export const WEBINARS = `${BACKOFFICE_LAYOUT}/webinars`;
export const WEBINARS_MENAGMENT = `${BACKOFFICE_LAYOUT}/web-menagement`;

export const MY_HUBS = `${BACKOFFICE_LAYOUT}/my-hubs`;

export const MY_HUBS_POWERPACKS = `${BACKOFFICE_LAYOUT}/my-hubs/power-packs`;
export const MY_HUBS_AKASHA = `${BACKOFFICE_LAYOUT}/my-hubs/supernode`;
export const MY_HUBS_TRAVEL = `${BACKOFFICE_LAYOUT}/my-hubs/travel-packages`;
export const MY_HUBS_BIG_WHALE = `${BACKOFFICE_LAYOUT}/my-hubs/big-whale`;
export const MY_HUBS_TRADING = `${BACKOFFICE_LAYOUT}/my-hubs/trading`;
export const MY_HUBS_PAYMENT = `${BACKOFFICE_LAYOUT}/my-hubs/payment`;
export const MY_HUBS_FLIPME_CARDS = `${BACKOFFICE_LAYOUT}/my-hubs/flipme-cards`;
export const MY_HUBS_GAMING = `${BACKOFFICE_LAYOUT}/my-hubs/gaming`;
export const MY_HUBS_STAKING = `${BACKOFFICE_LAYOUT}/my-hubs/staking`;

export const MY_TICKETS = `${BACKOFFICE_LAYOUT}/my-tickets`;

export const MY_TICKETS_WEBINAR_TICKETS = `${BACKOFFICE_LAYOUT}/my-tickets/webinar-tickets`;

export const MANAGE_AKASHA_NODE = `${BACKOFFICE_LAYOUT}/manage-super-node`;

export const MY_TEAM = `${BACKOFFICE_LAYOUT}/my-team`;

export const EARNINGS = `${BACKOFFICE_LAYOUT}/earnings`;

export const RANKING = `${BACKOFFICE_LAYOUT}/ranking`;

export const MONTLY = `${BACKOFFICE_LAYOUT}/montly`;

export const RESOURCES = `${BACKOFFICE_LAYOUT}/resources`;

// export const DUBAI_PROMOTION = `${BACKOFFICE_LAYOUT}/dubai-promotion`;

export const AIRDROPS = `${BACKOFFICE_LAYOUT}/airdrops`;

export const TRAVEL_PACKAGES = `${BACKOFFICE_LAYOUT}/travel-packages`;

export const CRUISES_PROMOTION = `${BACKOFFICE_LAYOUT}/event-promotion-cruises`;

export const BANGKOK_PROMOTION = `${BACKOFFICE_LAYOUT}/event-promotion-bangkok`;

export const SETTINGS_LAYOUT = `${BACKOFFICE_LAYOUT}/settings`;

export const SETTINGS_ACCOUNT = `${SETTINGS_LAYOUT}/account`;

export const SETTINGS_SECURITY = `${SETTINGS_LAYOUT}/security`;

export const SETTINGS_PAYMENTS = `${SETTINGS_LAYOUT}/payments`;

export const SETTINGS_NOTIFICATIONS = `${SETTINGS_LAYOUT}/notifications`;

export const SETTINGS_TEAM_SETTINGS = `${SETTINGS_LAYOUT}/team-settings`;

export const SETTINGS_VIRTUAL_OFFICE = `${SETTINGS_LAYOUT}/virtual-office`;

export const HELPDESK = `${BACKOFFICE_LAYOUT}/helpdesk`;

export const HELPDESK_SUPPORT = `${BACKOFFICE_LAYOUT}/helpdesk-support`;

export const HELPDESK_SUBCATEGORY = `${BACKOFFICE_LAYOUT}/subcategory`;

export const HELPDESK_QUESTION = `${BACKOFFICE_LAYOUT}/question`;

export const ACCOUNTING = `${BACKOFFICE_LAYOUT}/accounting`;

export const ORDER_ITEMS = `${BACKOFFICE_LAYOUT}/order-items`;
export const ORDER_INVOICES = `${BACKOFFICE_LAYOUT}/order-invoices`;

export const CASHBACK_BONUS = `${BACKOFFICE_LAYOUT}/cashback-bonus`;

export const POOL_BONUS = `${BACKOFFICE_LAYOUT}/pool-bonus`;

export const TOP_PERFORMER_BONUS = `${BACKOFFICE_LAYOUT}/top-performer-bonus`;

export const HODL_BONUS = `${BACKOFFICE_LAYOUT}/hodl-bonus`;

export const TERMS_OF_USE = `${BACKOFFICE_LAYOUT}/terms-of-use`;

export const PRIVACY_POLICY = `${BACKOFFICE_LAYOUT}/privacy-policy`;

export const COOKIE_POLICY = `${BACKOFFICE_LAYOUT}/cookie-policy`;

// export const GAMING = `${BACKOFFICE_LAYOUT}/gaming`;

export const PAYMENT = `${BACKOFFICE_LAYOUT}/payment`;

export const FINUP_HUBS = `${BACKOFFICE_LAYOUT}/finup-membership`;

export const POWERPACKS = `${BACKOFFICE_LAYOUT}/power-packs`;

export const AKASHA = `${BACKOFFICE_LAYOUT}/supernode`;

export const FLIPME_CARDS = `${BACKOFFICE_LAYOUT}/flipme-cards`;

export const TRADING = `${BACKOFFICE_LAYOUT}/trading`;

export const BIG_WHALE = `${BACKOFFICE_LAYOUT}/big-whale`;

// export const DUBAI_TOKEN_PROMOTION = `${BACKOFFICE_LAYOUT}/dubai-token-promotion`;

export const DISCOUNT_CODE = `${BACKOFFICE_LAYOUT}/discount-code`;

export const MARKETPLACE = `${BACKOFFICE_LAYOUT}/marketplace`;

export const FIRST_BUY_VIRTUAL_OFFICE = `${BACKOFFICE_LAYOUT}/first-buy-gift-bonus`;

export const SUPPORT_TICKETS = `${BACKOFFICE_LAYOUT}/support-tickets`;

// AUTH

export const LOGIN = `/login`;

export const LOGIN_TRAVELUTION = `/login-travelution`;

export const LOGIN_EARNBET = `/login-earnbet`;

export const FIRST_LOGIN = `/first-login`;

export const PROFILE_DETAILS = `/profile-details`;

export const SECURITY_CODE = `/security-code`;

export const PASSWORD = `/password`;

export const TERMS_AND_CONDITIONS = `/terms-and-conditions`;

export const REFERRAL = `/referral`;

export const EMAIL_ADDRESS = `/email-address`;

//KYC

export const KYC_LAYOUT = `/kyc`;

export const KYC_START = `${KYC_LAYOUT}/start`;

export const KYC_AGREEMENT = `${KYC_LAYOUT}/agreement`;

export const KYC_BIRTH_DETAILS = `${KYC_LAYOUT}/birth-details`;

export const KYC_DOCUMENT_DETAILS = `${KYC_LAYOUT}/document-details`;

export const KYC_DOCUMENT_PHOTOS = `${KYC_LAYOUT}/document-photos`;

export const KYC_SELFIE_TIME = `${KYC_LAYOUT}/selfie-time`;

export const KYC_CONGRATULATIONS = `${KYC_LAYOUT}/congratulations`;
